/*!
 * @piconetworks/spacing v3.1.4
 * (c) 
 */
'use strict';

var React = require('react');
var PropTypes = require('prop-types');
var cx = require('classnames');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var cx__default = /*#__PURE__*/_interopDefaultLegacy(cx);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var styles$2 = {"box":"RegularBox-module_box__FYskv","left":"RegularBox-module_left__20jaU","center":"RegularBox-module_center__3649L","right":"RegularBox-module_right__3XwiF"};

var RegularBox = function RegularBox(_ref) {
  var children = _ref.children,
      className = _ref.className,
      alignText = _ref.alignText,
      props = _objectWithoutProperties(_ref, ["children", "className", "alignText"]);

  return /*#__PURE__*/React__default['default'].createElement("div", _extends({
    className: cx__default['default'](styles$2[alignText], styles$2.box, className)
  }, props, {
    "data-testid": "Regular_RegularBox_div"
  }), children);
};

RegularBox.propTypes = {
  /** Aligns children using text-align */
  alignText: PropTypes__default['default'].oneOf(['left', 'center', 'right']),
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object])
};
RegularBox.defaultProps = {
  alignText: 'left'
};

var styles$1 = {"modalMarginPreset":"Margin-module_modalMarginPreset__3bg4o","defaultMarginPreset":"Margin-module_defaultMarginPreset__7V_TU","spaciousMarginPreset":"Margin-module_spaciousMarginPreset__3DmtO"};

var Margin = function Margin(_ref) {
  var children = _ref.children,
      className = _ref.className,
      preset = _ref.preset,
      props = _objectWithoutProperties(_ref, ["children", "className", "preset"]);

  return /*#__PURE__*/React__default['default'].createElement(RegularBox, _extends({
    className: cx__default['default'](styles$1.margin, styles$1["".concat(preset, "MarginPreset")], className)
  }, props, {
    "data-testid": "Margin_index_RegularBox"
  }), children);
};

Margin.propTypes = {
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),

  /** Required preset to ensure some normalcy */
  preset: PropTypes__default['default'].oneOf(['default', 'modal', 'spacious']).isRequired
};
Margin.defaultProps = {
  preset: 'default'
};

var styles = {"divider":"HorizontalDivider-module_divider__2aRSX","withLine":"HorizontalDivider-module_withLine__3-8SU","withChildren":"HorizontalDivider-module_withChildren__19-aW"};

var HorizontalDivider = function HorizontalDivider(_ref) {
  var children = _ref.children,
      className = _ref.className,
      withLine = _ref.withLine,
      props = _objectWithoutProperties(_ref, ["children", "className", "withLine"]);

  return /*#__PURE__*/React__default['default'].createElement("div", _extends({
    className: cx__default['default'](styles.divider, withLine && styles.withLine, children && styles.withChildren, className)
  }, props, {
    "data-testid": "HorizontalDivider_index_div"
  }), /*#__PURE__*/React__default['default'].createElement("span", {
    "data-testid": "HorizontalDivider_index_span"
  }, children));
};

HorizontalDivider.propTypes = {
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),

  /** Whether there will be text used for the children (which adds a line to the left and right of the text) */
  withLine: PropTypes__default['default'].bool
};
HorizontalDivider.defaultProps = {
  withLine: false
};

var Spacing = {
  HorizontalDivider: HorizontalDivider,
  Margin: Margin
};

module.exports = Spacing;
